import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { AuthShell } from "@/pages/Login";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";
import { toast } from "sonner";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const email = params.get("email") || "";
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/verify", { email, code });
      toast.success("Email verified — you can now log in.");
      nav("/login");
    } catch (err) { toast.error(err.response?.data?.detail || "Verification failed"); }
    finally { setLoading(false); }
  };

  const resend = async () => {
    try { await api.post("/auth/resend-verify", { email }); toast.success("New code sent"); }
    catch { toast.error("Could not resend"); }
  };

  return (
    <AuthShell title="Verify your email" subtitle={`We sent a 6-digit code to ${email}.`}>
      <form onSubmit={submit} className="space-y-6">
        <div className="flex justify-center">
          <InputOTP maxLength={6} value={code} onChange={setCode} data-testid="verify-otp">
            <InputOTPGroup>
              {[0,1,2,3,4,5].map((i) => <InputOTPSlot key={i} index={i} />)}
            </InputOTPGroup>
          </InputOTP>
        </div>
        <Button data-testid="verify-submit" disabled={loading || code.length < 6} className="btn-orange hover:bg-[#FF6A00] w-full py-6">
          {loading ? "Verifying..." : "Verify"}
        </Button>
        <div className="text-sm text-center text-slate-600">
          Didn't get it? <button type="button" onClick={resend} data-testid="verify-resend" className="text-brand font-semibold">Resend code</button>
        </div>
        <div className="text-xs text-center"><Link to="/login" className="text-slate-500">Back to login</Link></div>
      </form>
    </AuthShell>
  );
}
